<template>
  <div class="rootEl">
    <template slot="footer">
      <van-button v-show="false" @click="cancel">关闭</van-button>
    </template>
    <div style="height: 100vh; width: 100%">
      <baidu-map style="height: 100%; width: 100%" :center="currentPoint" :zoom="zoom" :scroll-wheel-zoom="true" @ready="initMap">
        <bm-marker
          :position="currentPoint"
          :icon="{
            url: require(`@/assets/car/online.png`),
            size: { width: 36, height: 36 }
          }"
          @click="openInfo"
        ></bm-marker>
        <bm-info-window :position="currentPoint" title="" :show="shows" class="info" style="width: 300px; min-height: 220px; font-size: 10px" @close="colseInfo">
          <div class="maskWindow">
            <div class="deviceInfo">
              <div class="carNo">
                {{ devicedata.carNum ? devicedata.carNum : devicedata.carVin }}
              </div>
              <div class="offlineTime" :class="'status' + devicedata.iconId">
                {{ devicedata.carDevice }}
              </div>
            </div>

            <div class="locationInfoItem">
              <span class="label">设备号：</span>
              <span class="value">{{ devicedata.sn }} ({{ devicedata.alias }}{{ devicedata.wifi === 1 ? '无线' : '有线' }})</span>
            </div>

            <div class="locationInfoItem">
              <span class="label">最后上报：</span>
              <span class="value">{{ devicedata.updateTime }}</span>
            </div>

            <div class="locationInfoItem">
              <span class="label">定位类型：</span>
              <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect">
                <template #reference>
                  <span class="value">{{ selectedLocationType.text }}</span>
                  <van-icon name="arrow-down" />
                </template>
              </van-popover>
            </div>
            <template v-if="selectedLocationType.value === 1">
              <div class="locationInfoItem">
                <span class="label">定位时间：</span>
                <span class="value">{{ devicedata.gpsTime }}</span>
              </div>

              <div class="locationInfoItem">
                <span class="label">定位位置：</span>
                <span class="value">{{ devicedata.gpsAddress }}</span>
              </div>
            </template>

            <template v-if="selectedLocationType.value === 2">
              <div class="locationInfoItem">
                <span class="label">定位时间：</span>
                <span class="value">{{ devicedata.gsmTime }}</span>
              </div>

              <div class="locationInfoItem">
                <span class="label">定位位置：</span>
                <span class="value">{{ devicedata.gsmAddress }}</span>
              </div>
            </template>

            <template v-if="selectedLocationType.value === 3">
              <div class="locationInfoItem">
                <span class="label">定位时间：</span>
                <span class="value">{{ devicedata.wifiTime }}</span>
              </div>

              <div class="locationInfoItem">
                <span class="label">定位位置：</span>
                <span class="value">{{ devicedata.wifiAddress }}</span>
              </div>
            </template>
          </div>
        </bm-info-window>
      </baidu-map>
    </div>
  </div>
</template>
<script>
import { getDeviceInfo } from '@/api/device'
export default {
  props: {},
  data() {
    return {
      zoom: 18,
      visible: false,
      shows: true,
      currentPoint: {
        lng: 120.320032,
        lat: 31.589666
      },
      devicedata: {
        // carvin: '粤B46500',
        // sn: '123123232',
        // reportGps: 1,
        // gpstime: '2023-02-24 14:35:00',
        // gpsAddress: '深圳市南山区高新园区北科大厦415',
        // updateTime: '2023-02-24 14:35:00',
        // alias: 'JR-02',
        // wifi: 1,
        // statusDevice: '油电通，设备在线',
        // brand: '马萨拉蒂'
      },
      BMap: null,
      map: null,
      key: '', // 外部参数 登录 Token
      fun: '', // 外部参数 功能
      imei: '', // 外部参数 设备号
      carVin: '', // 外部参数 车牌
      duration: 0, // 外部参数 时长限制
      time: '', // 外部参数 链接生成时间
      code: '', // 外部参数 验证码
      derationResult: null,
      intervalId: null,
      showPopover: false,
      selectedLocationType: { text: '卫星', value: 1 },
      actions: [
        { text: '卫星', value: 1 },
        { text: '基站', value: 2 },
        { text: 'WIFI', value: 3 }
      ],
      isFirstLoad: true
    }
  },
  watch: {
    $route: {
      handler(to) {
        const type = to.query.type
        // 外部调用 type 为1， 调用定位查询页面， 值为2 时调用轨迹查询页面
        if (type == 2) {
          this.$router.push({
            path: '/connect/contrail',
            query: { ...to.query }
          })
        }
      },
      immediate: true
    }
  },
  async mounted() {
    const { key, fun, imei, carVin, duration, time, code } = this.$route.query

    this.key = key
    this.fun = fun
    this.imei = imei
    this.carVin = carVin
    this.code = code

    this.derationResult = this.checkLinkExpiry(time, duration)
    if (this.derationResult.isExpired || !time || !code) {
      this.$dialog.alert({
        title: '提示',
        message: `链接已超时`
      })
    } else {
      this.intervalId = setInterval(() => {
        this.intshow()
        // this.derationResult = this.checkLinkExpiry(time, duration);
        // if(this.derationResult.isExpired || !time) {
        // 	if(this.devicedata['sn']) {
        // 		this.handelTimeout();
        // 			this.$dialog.alert({
        // 			title: '提示',
        // 			message: `链接已超时`,
        // 		})
        // 	}
        // }
      }, 5000)

      if (this.imei) {
        this.intshow()
      } else {
        this.$dialog
          .alert({
            title: '提示',
            message: `请传入需要定位的设备号`
          })
          .then(() => {})
      }
    }
  },

  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },

  methods: {
    onSelect(action) {
      console.log(action)
      this.selectedLocationType = action
    },

    // 查看轨迹
    viewGrack() {
      this.$router.push({
        path: '/connect/contrail',
        query: { ...this.$route.query }
      })
    },
    // 重绘地图定位
    initMap({ BMap, map }) {
      this.BMap = BMap
      this.map = map
    },
    cancel() {
      this.visible = false
    },
    colseInfo() {
      this.shows = false
    },
    openInfo() {
      this.shows = true
    },
    async intshow() {
      if (!this.imei) {
        return
      }
      const param = {
        // key: this.key,
        // fun: this.fun,
        imei: this.imei,
        code: this.code
        // carVin: this.carVin
      }
      const res = await getDeviceInfo(param)
      if (res && res.success) {
        this.devicedata = res.content[0]
        if (this.isFirstLoad) {
          this.isFirstLoad = false
          if (!this.devicedata.receiveTime) {
            this.selectedLocationType = { text: '卫星', value: 1 }
          } else {
            // 20260109 默认定位模式，根据LocalFlag判断
            this.selectedLocationType = this.actions.find(it => it.value === this.devicedata.localFlag)
          }
        }

        // 20260508 地图上的定位，以最新的定位时间判断是哪种定位模式，显示最新的定位 , 默认GPS
        const locationType = this.devicedata.localFlag || 1 

        this.currentPoint.lng = locationType === 1 ? this.devicedata.lon : locationType === 3 ? this.devicedata.wifiLon : this.devicedata.gsmLon
        this.currentPoint.lat = locationType === 1 ? this.devicedata.lat : locationType === 3 ? this.devicedata.wifiLat : this.devicedata.gsmLat

        this.zoom = 18
        this.shows = true
        this.visible = true
      } else {
        this.$dialog
          .alert({
            title: '提示',
            message: res.respMag
          })
          .then(() => {})
      }
    },

    checkLinkExpiry(generateTime, validHours) {
      const generateDate = new Date(generateTime)
      const expireTime = new Date(generateDate.getTime() + validHours * 60 * 60 * 1000)
      const currentTime = new Date()
      const remainingMs = expireTime - currentTime

      return {
        isExpired: currentTime > expireTime,
        remainingHours: Math.round((remainingMs / (60 * 60 * 1000)) * 10) / 10, // 保留一位小数
        expireTime: expireTime
      }
    },

    handelTimeout() {
      this.currentPoint = {
        lng: 120.320032,
        lat: 31.589666
      }

      this.devicedata = {}
    }
  }
}
</script>

<style lang="less" scoped>
.maskWindow {
  display: block;
  padding-bottom: 1em;

  .deviceInfo {
    padding-bottom: 1em;
    border-bottom: 1px solid #eee;
    margin-bottom: 1em;
    .carNo {
      font-size: 2em;
      font-weight: bold;
      margin-bottom: 0.6em;
    }
    .offlineTime {
      background-color: #c3c6c7;
      color: #fff;
      padding: 0.5em 1em;
      font-size: 1.2em;
      border-radius: 0.2em;
      &.status1 {
        background-color: #7bbf86;
      }
      &.status2 {
        background-color: #949aaf;
      }
      &.status3 {
        background-color: #6d79ff;
      }
      &.status4 {
        background-color: #ff7c7f;
      }
      &.status5 {
        background-color: #52abfd;
      }
      &.status6 {
        background-color: #fda448;
      }
    }
  }

  .locationInfoItem {
    margin-bottom: 1em;
    color: #64636d;
    font-size: 1.2em;
    font-weight: 500;
  }
}
</style>
